export const applicationEndpoints = {
  users: 'bo/users',
  permissions: 'bo/users/permissions',
  all: 'bo/users/all',
  usersToImpersonate: 'users/to-impersonate',
  impersonateUser: 'oauth2/impersonate/:userId',
  retrieveTranslations: 'lokalise/retrieveTranslationFiles',
  getRoleByCode: 'roles/get-by-code',
};
